import { PropsWithChildren, useRef } from 'react';
import {
	ApolloClient,
	ApolloLink,
	InMemoryCache,
	NormalizedCacheObject,
	concat,
	ApolloProvider as BaseApolloProvider,
} from '@apollo/client';

import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';
import { useHttpLink } from '@treams/auth';

export const ApolloProvider = ({ children }: PropsWithChildren) => {
	const workspace = useWorkspace();

	const client = useRef<ApolloClient<NormalizedCacheObject>>(
		// wtf is this
		null as unknown as ApolloClient<NormalizedCacheObject>,
	);

	// Expects an apolloClient but gets null?
	// hook also doesn't seem to have null checks
	const httpLink = useHttpLink(() => client.current, workspace.id);

	if (!client.current) {
		const authMiddleware = new ApolloLink((operation, forward) => {
			operation.setContext({
				headers: {
					...operation.getContext().headers,
					'content-type': 'application/json',
					'x-treams-workspace': workspace.id,
				},
			});

			return forward(operation);
		});

		client.current = new ApolloClient({
			cache: new InMemoryCache({
				typePolicies: {
					EvaluationSubmissionResult: {
						merge(existing, incoming) {
							return { ...existing, ...incoming };
						},
					},
					GoalConnection: {
						merge: true,
					},
				},
			}),
			link: concat(authMiddleware, httpLink),
			assumeImmutableResults: true,
			defaultOptions: {
				watchQuery: {
					fetchPolicy: 'cache-and-network',
				},
			},
		});
	}

	return <BaseApolloProvider client={client.current}>{children}</BaseApolloProvider>;
};
